module.exports = __webpack_public_path__ + "static/bg-a8f67cedee3ebab4c3d74b65f7c2849a.svg";